'use client'
import React, { createContext, useContext, ReactNode } from 'react'

export interface PageSettings {
  enableHeroGoogleLogin?: boolean
  enableHeaderGoogleLogin?: boolean
  enableInboxGoogleLogin?: boolean
  enablePricingGoogleLogin?: boolean
  enableTimeSavingsGoogleLogin?: boolean
  enableAiComparisonTableGoogleLogin?: boolean
  enableDictationGoogleLogin?: boolean
  enableDictateAndImproveGoogleLogin?: boolean
  enableAiModelsGoogleLogin?: boolean
  enableAiChatFeatureGoogleLogin?: boolean
  enableHyperAIGoogleLogin?: boolean
  enableTaskWriterGoogleLogin?: boolean
  

  showHeaderCTAs?:boolean
  showGoogleLogoHeader?: boolean // Controls whether Google logo is shown in buttons (defaults to true when Google login is enabled)
  showGoogleLogoHero?: boolean // Controls whether Google logo is shown in hero (defaults to true when Google login is enabled)
  showGoogleLogoHyperAI?: boolean // Controls whether Google logo is shown in hyper AI (defaults to true when Google login is enabled)
  showGoogleLogoInbox?: boolean // Controls whether Google logo is shown in inbox (defaults to true when Google login is enabled)
  showGoogleLogoPricing?: boolean // Controls whether Google logo is shown in pricing (defaults to true when Google login is enabled)
  showGoogleLogoTimeSavings?: boolean // Controls whether Google logo is shown in time savings (defaults to true when Google login is enabled)
  showGoogleLogoAiComparisonTable?: boolean // Controls whether Google logo is shown in ai comparison table (defaults to true when Google login is enabled)
  showGoogleLogoDictation?: boolean // Controls whether Google logo is shown in dictation (defaults to true when Google login is enabled)
  showGoogleLogoDictateAndImprove?: boolean // Controls whether Google logo is shown in dictate and improve (defaults to true when Google login is enabled)
  showGoogleLogoAiModels?: boolean // Controls whether Google logo is shown in ai models (defaults to true when Google login is enabled)
  showGoogleLogoAiChatFeature?: boolean // Controls whether Google logo is shown in ai chat feature (defaults to true when Google login is enabled)
  showGoogleLogoTaskWriter?: boolean // Controls whether Google logo is shown in task writer (defaults to true when Google login is enabled)
  
  googleLogoColor?: 'white' | 'black' | 'colorful' // Global Google logo color (defaults to 'colorful')

  // Email signup settings
  enableEmailSignup?: boolean // Enable email signup functionality in CTA buttons
  emailSignupVariant?: 'basic' | 'lean' | 'instant' // Variant: basic (button reveals input), lean (direct input), instant (direct input with redirect)
}

const PageSettingsContext = createContext<PageSettings>({})

interface PageSettingsProviderProps {
  children: ReactNode
  settings?: PageSettings
}

export const PageSettingsProvider: React.FC<PageSettingsProviderProps> = ({
  children,
  settings = {},
}) => {
  return (
    <PageSettingsContext.Provider value={settings}>
      {children}
    </PageSettingsContext.Provider>
  )
}

export const usePageSettings = (): PageSettings => {
  return useContext(PageSettingsContext)
}

